// import { createSortOption } from "@nosto/preact"

// export const SIZES_LENGTH = 5;

// export const settings = window?.domaineSettings || {
//     'shop_name': 'NOBULL',
//     'sibling_collections': [],
//     'products_per_page': "24",
//     'popular_searches_terms': "women\nsale\nshoes\nlifter\ngolf",
//     'search_product_list': [],
//     'may_like_products_list_no_results': [],
// }

// // export const sizes = Array.from({ length: SIZES_LENGTH }, (_, i) => (i + 1) * settings.products_per_page); //[24, 48, 72]
// export const sizes = [24]; // Hardcoded to 24

// export const sortOptions = [
//     createSortOption("score", "Featured", { field: "score", order: "desc" }),
//     createSortOption("-price", "Price: High to Low", { field: "price", order: "desc" }),
//     createSortOption("price", "Price: Low to High", { field: "price", order: "asc" }),
//     createSortOption("newest", "Newest", { field: "created", order: "desc" }),
//     createSortOption("mostPopular", "Most Popular", { field: "best-selling", order: "desc" })
// ]

// export const defaultConfig = {
//     sort: sortOptions[0],
//     serpSize: sizes[0],
//     autocompleteProductsSize: 4,
//     autocompleteKeywordsSize: 5,
//     historySize: 5,
//     showPaginationInfo: false,
//     inputCssSelector: "#Search-In-Modal-Nosto",
// }
import { createSortOption } from "@nosto/preact"

export const SIZES_LENGTH = 5;

export const settings = window?.domaineSettings || {
    'shop_name': 'NOBULL',
    'sibling_collections': [],
    'products_per_page': "24",
    'popular_searches_terms': "women\nsale\nshoes\nlifter\ngolf",
    'search_product_list': [],
    'may_like_products_list_no_results': [],
}

/**
 * Product Grid Page browsing behaviour.
 * Only meaningful when the new layout is active (window.isNewLayout, driven by a
 * collection metafield). Values are injected from theme Liquid via window.pgpBrowsing.
 *
 *   window.pgpBrowsing = {
 *     mode: 'pagination' | 'infinite',
 *     perPage: <number>,   // products shown per page in pagination mode
 *     batchSize: <number>, // products loaded per batch in infinite mode
 *   }
 *
 * When the new layout is OFF, we fall back to the classic behaviour (serpSize = 24).
 */
const isNewLayout = typeof window !== 'undefined' && !!window.isNewLayout;
const pgp = (typeof window !== 'undefined' && window.pgpBrowsing) || {};

export const browsingMode = isNewLayout ? (pgp.mode === 'infinite' ? 'infinite' : 'pagination') : 'pagination';
export const isInfiniteScroll = isNewLayout && browsingMode === 'infinite';

// Per-mode page size (kept as separate variables; serpSize below stays as-is for
// the classic layout / other surfaces that already rely on it).
const CLASSIC_SIZE = 24;
export const perPageSize = Number(pgp.perPage) > 0 ? Number(pgp.perPage) : Number(settings.products_per_page) || CLASSIC_SIZE;
export const batchSize   = Number(pgp.batchSize) > 0 ? Number(pgp.batchSize) : Number(settings.products_per_page) || CLASSIC_SIZE;

// The size Nosto actually requests per query. In the new layout this follows the
// selected mode; otherwise it is the classic hardcoded 24.
export const activeSerpSize = isNewLayout
    ? (isInfiniteScroll ? batchSize : perPageSize)
    : CLASSIC_SIZE;

// export const sizes = Array.from({ length: SIZES_LENGTH }, (_, i) => (i + 1) * settings.products_per_page); //[24, 48, 72]
export const sizes = [activeSerpSize]; // single option, driven by mode/settings

export const sortOptions = [
    createSortOption("score", "Featured", { field: "score", order: "desc" }),
    createSortOption("-price", "Price: High to Low", { field: "price", order: "desc" }),
    createSortOption("price", "Price: Low to High", { field: "price", order: "asc" }),
    createSortOption("newest", "Newest", { field: "created", order: "desc" }),
    createSortOption("mostPopular", "Most Popular", { field: "best-selling", order: "desc" })
]

export const defaultConfig = {
    sort: sortOptions[0],
    serpSize: sizes[0],
    autocompleteProductsSize: 4,
    autocompleteKeywordsSize: 5,
    historySize: 5,
    showPaginationInfo: false,
    inputCssSelector: "#Search-In-Modal-Nosto",
}
